<template>
  <div class="data-ingredient">
    <div
      class="page-header"
      style="margin-bottom:15px"
    >系统设置</div>
    <div style="padding:0 15px 15px 15px;text-align:left">
      <el-switch
      v-model="sysMode.openStatus"
      active-color="#13ce66"
      inactive-color="#DCDFE6"
      :active-value="1"
      :inactive-value="0"
      @change="(nval)=>sysChange(nval)"
    >
    </el-switch>
    <span style="font-size:12px;display:inline-block;margin-left:12px">{{sysMode.openStatus==1?'系统开启中':'系统关闭'}}</span>
    <el-input type="textarea"  placeholder="请输入内容"
      v-if="sysMode.openStatus==0 && !sysMode.closeDesc || isEdit"
      v-model="sysMode.closeDesc"
      maxlength="300"
      style="margin-top:15px;margin-bottom:15px"
      :rows="5"
      show-word-limit>
    </el-input>
    <el-row v-if="sysMode.openStatus==0 && sysMode.closeDesc">
      <el-col :span="10" v-if="!isEdit">
        {{sysMode.closeDesc}}
      </el-col>
      <el-col style="font-size: 12px;color:blue;text-align:center" :span="3">
        <a
           v-if="!isEdit"
          class="el-link--default"
          @click="edit"
        ><span class="el-link--inner">编辑</span></a>
      </el-col>
    </el-row>
    <el-row :span="10" style="text-align:center" v-if="isEdit">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="cancle">取消</el-button>
    </el-row>
    </div>
  </div>
</template>

<script>
import { fetchSysStatus,saveSysStatus } from "@/api/sysset.js";
export default {
  name: 'sysmange',
  data(){
    return {
      isEdit: false,
      sysMode: {
        id: null,
        closeDesc: null,
        openStatus: 1
      }
    }
  },
  created() {
    this.fetchSysStatus();
  },
  methods: {
    fetchSysStatus() {
      fetchSysStatus().then(response=>{
        this.sysMode = response.data;
      })
    },
    save() {
      saveSysStatus(this.sysMode).then(response=>{
        this.$message({
					message: '系统状态更改成功！',
					type: 'success'
        });
        this.fetchSysStatus();
      })
    },
    edit() {
      this.isEdit = true;
    },
    cancle() {
      this.isEdit = false;
      this.fetchSysStatus();
    },
    sysChange(nval) {
      if(nval == 1) {
        this.isEdit = false;
        this.sysMode.openStatus = nval;
        saveSysStatus(this.sysMode).then(response=>{
        this.$message({
					message: '系统状态更改成功！',
					type: 'success'
        });
        this.fetchSysStatus();
      })
      }
      if(nval == 0) {
        this.isEdit = true;
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/datacenter/components/eeopset/sysset/index.vue